import { get } from "../api.js";

/**
 * @typedef {import("../jsdoc/ApprovedContractor.js").ApprovedContractor} ApprovedContractor
 */

/**
 * Gets list of Approved Contractors
 * @returns {Promise<ApprovedContractor[]>}
 */
export const getApprovedContractorsList = () =>
  get("/sewppublic/approvedcontractors/list").then(({ data }) => data);
